import FaqContainer from "../../Componant/Faq";

const Faq = () => {
  return (
    <div className="page-body">
      <FaqContainer />
    </div>
  );
};

export default Faq;
